import { render, staticRenderFns } from "./PreparacionEquiposPantalla.vue?vue&type=template&id=49266074&"
import script from "./PreparacionEquiposPantalla.vue?vue&type=script&lang=ts&"
export * from "./PreparacionEquiposPantalla.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports